import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthGuard } from './auth.guard';

@Injectable({ providedIn: 'root' })
export class DocumentHistoryGuard implements CanActivate {
  constructor(private authGuard: AuthGuard) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // The email endpoint validates the scoped credential and current document permissions.
    if (new URLSearchParams(route.fragment || '').has('access')) {
      return true;
    }
    return this.authGuard.canActivate(route, state);
  }
}
